export default {
    parts: ['sidebar', 'sidebarItem', 'tabs', 'tabItem'],
    baseStyle: {
        sidebar: {
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            position: 'sticky',
            top: '50px',
            minWidth: '225px',
            width: '225px',
            flexShrink: 0,
            zIndex: 1
        },
        sidebarItem: {
            display: 'block',
            textStyle: 'bodyMdRegular',
            textTransform: 'capitalize',
            textDecoration: 'none',
            cursor: 'pointer',
            color: 'webTypo.textTertiary',
            _hover: {color: 'webTypo.textPrimary', textDecoration: 'none'},
            '&[data-active=true]': {
                color: 'webTypo.textPrimary',
                textStyle: 'bodyMdBold'
            }
        },
        tabs: {
            display: 'flex',
            gap: 4,
            overflowX: 'auto',
            borderBottom: '1px solid',
            borderColor: 'gray.200',
            marginY: '48px',
            paddingLeft: 4,
            position: 'sticky',
            top: '49px',
            zIndex: 1000,
            bg: 'webTheme.backgroundDefault',
            '&::-webkit-scrollbar': {display: 'none'}
        },
        tabItem: {
            textStyle: 'labelXs',
            flexShrink: 0,
            paddingX: 2,
            paddingY: '13px',
            textTransform: 'capitalize',
            bg: 'transparent',
            border: 'none',
            borderBottom: '1px solid',
            borderBottomColor: 'transparent',
            cursor: 'pointer',
            whiteSpace: 'nowrap',
            color: 'webTypo.textPrimary',
            _focus: {outline: 'none', boxShadow: 'outline'},
            '&[data-active=true]': {
                borderBottomColor: 'webTheme.strokeDefault'
            }
        }
    }
}
